import $ from 'jquery';
import _ from 'underscore';
import Cache from 'root/cache';
import Config from 'root/config';
import UI from 'root/ui';
import Modal from 'root/module/modal';
import Util from 'root/module/util';
import Form from 'root/module/form';
import View from 'view/base';

export default View.extend({
    subdomain_availability: {},

    events: {
        'click .workspace-url-change'     : 'onToggleSubdomain',
        'keydown input[name="subdomain"]' : 'onBeforeChangeSubdomain',
        'input input[name="subdomain"]'   : 'onChangeSubdomain',
        'click .enforce_2fa'              : 'onToggleEnforce2fa',
        'click .logo-upload'              : 'onSelectLogo',
        'click .logo-remove'              : 'onRemoveLogo',
        'input input[type="text"]'        : 'onFormChange',
        'change select'                   : 'onFormChange',
        'click .subdomain-submit'         : 'onSubmitSubdomain',
        'click .subdomain-cancel'         : 'onCancelSubdomain',
        'submit .form-general'            : 'onSubmitGeneral'
    },

    dom_handlers: {
        onToggleSubdomain: function(e) {
            e.preventDefault();

            this.$el.find('.workspace-url-preview').hide();
            this.$el.find('.input-subdomain').show();
            this.$el.find('.subdomain-submit').show();
            this.$el.find('.subdomain-cancel').show();

            this.$el.find('input[name="subdomain"]').focus();
        },

        onCancelSubdomain: function(e) {
            e.preventDefault();

            this.$el.find('.workspace-url-preview').show();
            this.$el.find('.input-subdomain').hide();
            this.$el.find('.subdomain-submit').hide();
            this.$el.find('.subdomain-cancel').hide();
        },

        onBeforeChangeSubdomain: function(e) {
            if (!e.key.match(/[a-zA-Z0-9-]/)) {
                e.preventDefault();
                return;
            }
        },

        onChangeSubdomain: function(e) {
            var subdomain = $(e.currentTarget).val().trim();

            var subdomain_sanitised = Util.sanitizeCustomSubdomain(subdomain);

            if (subdomain !== subdomain_sanitised) {
                $(e.currentTarget).val(subdomain_sanitised);
            }

            if (!subdomain_sanitised) {
                this.$el.find('.url-taken').hide();
                this.$el.find('.url-validation').html('');
                return;
            }

            if (subdomain_sanitised !== this.model.get('subdomain')) {
                clearTimeout(this.subdomain_timeout);
                this.subdomain_timeout = setTimeout(() => {
                    this.checkSubdomain(subdomain_sanitised);
                }, 100);
            }
        },

        onToggleEnforce2fa: function(e) {
            e.stopPropagation();

            var enforce_2fa = !this.model.get('enforce_2fa');

            var title = enforce_2fa ? 'Are you sure you want to enforce 2FA for your workspace members?' : 'Are you sure you want to turn 2FA off for your workspace?';
            var confirm_btn = enforce_2fa ? 'Yes, enforce' : 'Yes, turn off';

            Modal.confirm(title, function(e) {
                this.model.set('enforce_2fa', enforce_2fa);

                if (enforce_2fa) {
                    this.$el.find('.enforce_2fa').addClass('switch-on').removeClass('switch-off');
                } else {
                    this.$el.find('.enforce_2fa').addClass('switch-off').removeClass('switch-on');
                }

                Cache.app.request({
                    action: 'workspace/update',
                    data: {
                        workspace_id: this.model.id,
                        enforce_2fa : enforce_2fa,
                    },
                    success: () => {
                        if (this.$el.find('.enforce_2fa').hasClass('switch-on')){
                            UI.success('Two-factor authentication turned on');
                        } else if (this.$el.find('.enforce_2fa').hasClass('switch-off')){
                            UI.success('Two-factor authentication turned off');
                        }
                    }
                });
            }, this, confirm_btn, undefined, 'primary');
        },

        onSelectLogo: function(e) {
            e.preventDefault();

            Util.uploadImages(1, 10, (result) => {
                var image_result = result[0];
                var upload_error = this.$el.find('.logo-upload-error');

                if (image_result.error) {
                    upload_error.text(image_result.error);
                } else {
                    upload_error.text('');

                    this.logo_file = {
                        content : image_result.content,
                        type    : image_result.type,
                        name    : image_result.name
                    };
                }

                this.renderLogo();
                this.checkFormChange();
            });
        },

        onRemoveLogo: function() {
            this.logo_file = {
                content : 'delete',
                type    : 'delete',
                name    : 'delete'
            }

            this.renderLogo();
            this.checkFormChange();
        },

        onFormChange: function() {
            this.checkFormChange();
        },

        onSubmitSubdomain: function() {
            var form_data = {...Form.getData(this.$el.find('.form-subdomain')),
                workspace_id: this.model.id
            };

            var new_url = form_data.subdomain + Cache.app.configs.workspace_host;
            var message = '<p>Are you sure you want to change workspace URL to<br><b>' + new_url + '</b>?</p><p>This will change all your URLs and old ones can\'t be accessible anymore.</p>';
            Modal.confirm(message, () => {
                this.$el.find('.subdomain-submit').addClass('loading').prop('disabled', true);

                Cache.app.request({
                    action: 'workspace/update',
                    data: form_data,
                    success: (response) => {
                        this.model.set(response);
                        UI.success('Workspace URL updated');

                        // refresh to new workspace url
                        window.location = this.model.getUrl() + '/account/';
                    },
                    complete: () => {
                        this.$el.find('.general-submit').removeClass('loading').prop('disabled', false);
                    }
                });
            }, this, 'Yes, change');
        },

        onSubmitGeneral: function(e) {
            var form_data = {...Form.getData(this.$el.find('.form-general')),
                workspace_id : this.model.id,
                logo_content : this.logo_file.content,
                logo_type    : this.logo_file.type,
                logo_name    : this.logo_file.name
            };

            this.$el.find('.general-submit').addClass('loading').prop('disabled', true);

            Cache.app.request({
                action: 'workspace/update',
                data: form_data,
                success: (response) => {
                    this.model.set(response);
                    UI.success('Workspace settings updated');
                },
                complete: () => {
                    this.$el.find('.general-submit').removeClass('loading').prop('disabled', false);
                }
            });

            Cache.app.request({
                action: 'account/saveDetails',
                data: {
                    company  : form_data.display_name,
                    country  : form_data.country,
                    timezone : form_data.timezone, // TODO: migrate timezone to workspace
                    phone    : form_data.phone
                },
                success: (response) => {
                    Cache.account.set(response);
                }
            });
        }
    },

    initialize: function() {
        this.logo_file = {
            content : '',
            type    : '',
            name    : ''
        };
    },

    checkSubdomain: function(subdomain) {
        // cached result
        if (typeof this.subdomain_availability[subdomain] !== 'undefined') {
            this.renderSubdomainValidation(this.subdomain_availability[subdomain]);
            return;
        }

        this.$el.find('.url-validation').html('<i class="far fa-sync-alt fa-spin text-info"></i>');

        Cache.app.request({
            action: 'workspace/checkSubdomain',
            data: {
                subdomain: subdomain
            },
            error: () => {
                this.subdomain_availability[subdomain] = false;
                this.renderSubdomainValidation(false);
            },
            success: (response) => {
                this.subdomain_availability[subdomain] = true;
                this.renderSubdomainValidation(true);
            }
        });
    },

    renderSubdomainValidation: function(success) {
        if (success) {
            this.$el.find('.url-validation').html('<i class="far fa-check text-success"></i>');
            this.$el.find('.url-taken').hide();
        } else {
            this.$el.find('.url-validation').html('<i class="far fa-times text-danger"></i>');
            this.$el.find('.url-taken').show();
        }
    },

    checkFormChange: function() {
        var form_subdomain = Form.getData(this.$el.find('.form-subdomain'));
        var form_general   = {...Form.getData(this.$el.find('.form-general')),
            logo_content : this.logo_file.content
        };

        var is_subdomain_changed = false;
        var is_general_changed   = false;

        if (this.$el.find('.url-taken').is(':visible')) {
            is_subdomain_changed = false;
        } else if (form_subdomain.subdomain !== this.model.get('subdomain')) {
            is_subdomain_changed = true;
        }

        if (form_general.display_name !== this.model.get('display_name')) {
            is_general_changed = true;
        } else if (form_general.logo_content) {
            is_general_changed = true;
        } else if (form_general.country !== Cache.account.get('country')) {
            is_general_changed = true;
        } else if (form_general.timezone !== Cache.account.get('timezone')) {
            is_general_changed = true;
        } else if (form_general.phone != Cache.account.get('phone')) {
            is_general_changed = true;
        }

        this.$el.find('.subdomain-submit').prop('disabled', !is_subdomain_changed);
        this.$el.find('.general-submit').prop('disabled', !is_general_changed);
    },

    renderLogo: function() {
        var content = '';

        if (this.logo_file.content && this.logo_file.content !== 'delete') {
            content += '<img src="' + this.logo_file.content + '">';
            content += '<button type="button" class="logo-remove"><i class="fa-solid fa-times"></i></button>';
        } else if (this.model.get('logo_url') && this.logo_file.content !== 'delete') {
            content += '<img src="' + this.model.get('logo_url') + '">';
            content += '<button type="button" class="logo-remove"><i class="fa-solid fa-times"></i></button>';
        } else {
            content += '<span>' + Util.htmlEntities(this.model.getName().slice(0, 2)) + '</span>';
        }

        content += '<a href="#" class="logo-upload">Upload Logo</a>';

        this.$el.find('.workspace-logo').html(content);
    },

    render: function() {
        var country_options = '<option value="">Select...</option>';
        _.each(Config.country_list, (country, value) => {
            country_options += '<option value="' + value +  '">' + country + '</option>';
        });

        var timezone_options = '';
        _.each(Config.timezone_list, (timezone, value) => {
            timezone_options += '<option value="' + value +  '">' + timezone + '</option>';
        });

        var content =
        '<div>Manage your workspace settings.</div>' +
        '<div class="divider-24"></div>' +
        '<div class="form-subdomain box box-nopadding">' +
            '<div class="grid-4-8 grid-none-mobile padding-48 padding-20-phone">' +
                '<div>' +
                    '<h3 class="margin-top-8">Workspace URL</h3>' +
                '</div>' +
                '<div>' +
                    '<div class="workspace-url-preview">' +
                        '<a class="primary workspace-url-change" href="#">Change</a>' +
                        '<div>' + this.model.getUrl() + '</div>' +
                    '</div>' +
                    '<div class="input-subdomain">' +
                        '<div>' +
                            '<span class="url-validation"><i class="far fa-check text-success"></i></span>' +
                            '<span class="subdomain">' +
                                '<input type="text" name="subdomain" maxlength="30" data-validation="string" spellcheck="false" placeholder="mycompany">' +
                            '</span>' +
                            '<span class="host-name">' + Cache.app.configs.workspace_host + '</span>' +
                        '</div>' +
                    '</div>' +
                    '<div class="text-danger text-medium margin-top-8 float-left url-taken">This url is already taken</div>' +
                    '<div class="text-align-right margin-top-12">' +
                        '<a class="subdomain-cancel text-info" href="#">Cancel</a>' +
                        '<button type="button" class="subdomain-submit primary small" disabled>Save</button>' +
                    '</div>' +
                '</div>' +
            '</div>' +
        '</div>' +
        '<div class="form-subdomain box box-nopadding">' +
            '<div class="padding-48 padding-20-phone">' +
                '<div class="margin-top-8 setting-toggle">' +
                    '<button type="button" class="small ' + (this.model.get('enforce_2fa') ? 'switch-on' : 'switch-off') + ' enforce_2fa"></button>' +
                '</div>' +
                '<div>' +
                    '<h3 class="margin-top-8">Two-factor authentication for your workspace</h3>' +
                '</div>' +
                '<div class="text-info text-medium">Enforce 2FA (email) for all the workspace members upon login.</div>' +
            '</div>' +
        '</div>' +
        '<form class="form-general box box-nopadding">' +
            '<div class="grid-4-8 grid-none-mobile padding-48 padding-20-phone">' +
                '<div>' +
                    '<h3 class="margin-top-8">Workspace name</h3>' +
                '</div>' +
                '<div>' +
                    '<input type="text" class="solid medium" name="display_name" maxlength="100" required>' +
                '</div>' +
            '</div>' +

            '<hr class="xsmall">' +

            '<div class="grid-4-8 grid-none-mobile padding-48 padding-20-phone">' +
                '<div>' +
                    '<h3>Workspace logo</h3>' +
                    '<div class="text-info text-medium">Recommended size: 128 x 128<br>(png, jpg or svg)</div>' +
                '</div>' +
                '<div>' +
                    '<div class="workspace-logo"></div>' +
                    '<div class="logo-upload-error hidden-empty text-danger text-medium margin-top-12"></div>' +
                '</div>' +
            '</div>' +

            '<hr class="xsmall">' +

            '<div class="grid-4-8 grid-none-mobile padding-48 padding-20-phone">' +
                '<div>' +
                    '<h3 class="margin-top-8">Country</h3>' +
                '</div>' +
                '<div>' +
                    '<div><select class="solid medium" name="country">' + country_options + '</select></div>' +
                '</div>' +
            '</div>' +

            '<hr class="xsmall">' +

            '<div class="grid-4-8 grid-none-mobile padding-48 padding-20-phone">' +
                '<div>' +
                    '<h3 class="margin-top-8">Timezone</h3>' +
                '</div>' +
                '<div>' +
                    '<div><select class="solid medium" name="timezone">' + timezone_options + '</select></div>' +
                '</div>' +
            '</div>' +

            '<hr class="xsmall">' +

            '<div class="grid-4-8 grid-none-mobile padding-48 padding-20-phone">' +
                '<div>' +
                    '<h3 class="margin-top-8">Contact Number</h3>' +
                '</div>' +
                '<div>' +
                    '<div><input class="solid medium" type="text" name="phone" data-validation="string"></div>' +
                '</div>' +
            '</div>' +

            /*
            '<div class="padding-48 padding-20-phone">' +
                '<div class="setting-toggle">' +
                    '<button type="button" class="fsmall switch-off"></button>' +
                '</div>' +
                '<div>' +
                    '<h3>Joining this workspace</b></h3>' +
                '</div>' +
                '<div class="text-info text-medium">Allow people to join this workspace when they sign up using email address from these domains:</div>' +
                '<textarea class="solid margin-top-24" rows="5"></textarea>' +
            '</div>' +
            */

            '<hr class="xsmall">' +

            '<div class="text-align-right padding-48 padding-20-phone">' +
                '<button class="general-submit primary" type="submit" disabled>Save Changes</button>' +
            '</div>' +
        '</form>';

        this.$el.html(content);

        this.renderLogo();

        Form.setData(this.$el.find('.form-subdomain'), this.model.attributes);
        Form.setData(this.$el.find('.form-general'), {...this.model.attributes, ...Cache.account.attributes});

        return this;
    }
});